import PropTypes from 'prop-types';

import { Announcement, Error, Layout, TableData, Loader } from '@utilities';

const RawData = ({ isRawDataLoading, isTooMuchData, rawData, rawDataLoadingError }) => {
  if (rawDataLoadingError) return <Error status={rawDataLoadingError?.response?.status} />;
  if (isRawDataLoading) return <Loader isCentered />;

  return (
    <Layout.Flex.Column>
      {isTooMuchData && (
        <Announcement
          header="Too much data"
          text="There's too much data to reasonably render to your browser. Only a sample is shown. Please Download the Raw Data to view all the details."
          variant="error"
        />
      )}
      {rawData?.map((data, index) => (
        <TableData
          columns={data?.table?.columns}
          data={data?.table?.data}
          key={`raw-data-${index}`}
          size={20}
        />
      ))}
    </Layout.Flex.Column>
  );
};

RawData.propTypes = {
  isRawDataLoading: PropTypes.bool,
  isTooMuchData: PropTypes.bool,
  rawData: PropTypes.arrayOf(PropTypes.object),
  rawDataLoadingError: PropTypes.object,
};

export default RawData;
